const bedRouter = {
  path: "/bedPage", //主体
  name: "bedPage",
  redirect: "/project",
  component: () => import("../views/bedPage/main"),
  children: [
    {
      path: "/project",
      name: "project",
      mate: {
        title: "项目管理"
      },
      component: () => import("../views/bedPage/project/index")
    },
    {
      path: "/bedSetting",
      name: "bedSetting",
      mate: {
        title: "床位设置"
      },
      component: () => import("../views/bedPage/bedSetting/index")
    },
    {
      path: "/servicePersonnel",
      name: "servicePersonnel",
      mate: {
        title: "服务人员"
      },
      component: () => import("../views/bedPage/servicePersonnel/index")
    },
    {
      path: "/serviceOld",
      name: "serviceOld",
      mate: {
        title: " 服务老人"
      },
      component: () => import("../views/bedPage/serviceOld/index")
    },
    {
      path: "/serviceList",
      name: "serviceList",
      mate: {
        title: "服务工单"
      },
      component: () => import("../views/bedPage/serviceList/index")
    },
    {//纯展示服务工单
      path: "/serviceListshow",
      name: "serviceListshow",
      mate: {
        title: "服务工单"
      },
      component: () => import("../views/bedPage/serviceListshow/index")
    },
    {
      path: "/emergency",
      name: "emergency",
      mate: {
        title: "应急工单"
      },
      component: () => import("../views/bedPage/emergency/index")
    },
    {
      path: "/emergencyewm",
      name: "emergencyewm",
      mate: {
        title: "应急工单"
      },
      component: () => import("../views/bedPage/emergency/ewmPage")
    },
    {
      path: "/train",
      name: "train",
      mate: {
        title: " 培训管理"
      },
      component: () => import("../views/bedPage/train/index")
    },

    {
      path: "/dictionary",
      name: "dictionary",
      mate: {
        title: "数据字典"
      },
      component: () => import("../views/bedPage/dictionary/index"),
      redirect: "/deviceManage",
      children: [
        {
          path: "/deviceManage",
          name: "deviceManage",
          mate: {
            title: "设备管理"
          },
          component: () => import("../views/bedPage/dictionary/deviceManage")
        },
        {
          path: "/equipmentLocation",
          name: "equipmentLocation",
          mate: {
            title: "设备位置"
          },
          component: () =>
            import("../views/bedPage/dictionary/equipmentLocation")
        },
        {
          path: "/serviceCategory",
          name: "serviceCategory",
          mate: {
            title: "服务类别"
          },
          component: () => import("../views/bedPage/dictionary/serviceCategory")
        },
        {
          path: "/certificateName",
          name: "certificateName",
          mate: {
            title: "证书名称"
          },
          component: () => import("../views/bedPage/dictionary/certificateName")
        },
        {
          path: "/oldRelationship",
          name: "oldRelationship",
          mate: {
            title: "与老人关系"
          },
          component: () => import("../views/bedPage/dictionary/oldRelationship")
        },
        {
          path: "/certificateType",
          name: "certificateType",
          mate: {
            title: "证书类型"
          },
          component: () => import("../views/bedPage/dictionary/certificateType")
        },
        {
          path: "/skill",
          name: "skill",
          mate: {
            title: "培训技能"
          },
          component: () => import("../views/bedPage/dictionary/skill")
        },
        {
          path: "/makeAnAppointment",
          name: "makeAnAppointment",
          mate: {
            title: "预约来源"
          },
          component: () =>
            import("../views/bedPage/dictionary/makeAnAppointment")
        },
        // 预约管理路由
        {
          path: "/serviceObject",
          name: "serviceObject",
          mate: {
            title: "服务"
          },
          component: () => import("../views/bedPage/dictionary/serviceObject")
        }
      ]
    },
    {
      path: "/appointment",
      name: "appointment",
      mate: {
        title: "预约管理"
      },
      component: () => import("../views/bedPage/appointment/index.vue")
    },
    {
      path: "/returnVisitManagement",
      name: "returnVisitManagement",
      mate: {
        title: "回访管理"
      },
      component: () =>
        import("../views/bedPage/returnVisitManagement/index.vue")
    }
  ]
}

export default bedRouter
